import api from '@/plugins/request/index';

// 获取可切换商户列表
export const getCheckStoreList = async (type = 'get') => {
  return api[type]('/gateway/v1/admin/selected-company').then(res => res);
}
// 获取文件上传秘钥
export const getSecretApi = async (type = 'get') => {
  return api[type]('/gateway/v1/upload/tmp-key').then(res => res);
}
// 获取公用配置文件
export const getBaseConfig = async (key = '', type = 'get') => {
  return api[type]('/gateway/v1/config/crm', key && key !== '' && {name: key}).then(res => res);
}
// 更新当前用户信息
export const referenceUserProfile = async (type = 'get') => {
  return api[type]('/gateway/v1/profile').then(res => res);
}
// 获取项目列表
export const getProjectList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/project', params).then(res => res);
}
// 获取登录图片验证码
export const getImageCode = async (category = 'default', type = 'get') => {
  return api[type](`/gateway/v1/captcha/${category}`).then(res => res);
}
// 获取当前登录公司详情
export const getCompanyInfo = async (type = 'get') => {
  return api[type]('/gateway/v1/company/info').then(res => res);
}
// 获取二手房平台列表
export const getEsfPlatform = async (type = 'get') => {
  return api[type]('/gateway/v1/company/platform-for-esf').then(res => res);
}
// 检验手机号是否使用
export const checkMobile = async (params, type = 'get') => {
  return api[type]('/gateway/v1/admin/check-mobile', params).then(res => res);
}
// 检验手机号是否使用
export const checkMobileV2 = async (params, type = 'get') => {
  return api[type]('/gateway/v1/admin/check-mobile-v2', params).then(res => res);
}
// 获取当前用户权限下的部门列表
export const getDepartmentByUser = async (type = 'get') => {
  return api[type]('/gateway/v1/dept/list-by-admin').then(res => res);
}
// 意向区域联动搜索
export const getAreaCity = async (params, type = 'get') => {
  return api[type]('/gateway/v1/city/search', params).then(res => res);
}
// 意向区域联动搜索
export const getCityByLevel= async (level,upId, type = 'get') => {
  return api[type]('/gateway/v1/city/'+level+'/'+upId).then(res => res);
}
// 意向楼盘联动搜索
export const getHouseList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/project', params).then(res => res);
}
// 用户名联动搜索
export const getUserNameAutoList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/customer/search-name', params).then(res => res);
}
// 联系人姓名联动搜索
export const getConcatAutoList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/customer/search-contact-name', params).then(res => res);
}
// 经纪人联动搜索
export const getAdminAutoList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/admin/search-name', params).then(res => res);
}
// 商机客户名称联动搜索
export const getBussinessAdminAutoList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/business/search-customer-name', params).then(res => res);
}
// 订单客户名称联动搜索
export const getOrderAdminAutoList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/order/search-customer-name', params).then(res => res);
}
// 跟进记录客户名称联动
export const getFollowAdminAutoList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/log/follow/search-customer-name', params).then(res => res);
}
// 获取今日简报
export const getTodayTotal = async (params, type = 'get') => {
  return api[type]('/gateway/v1/statistics/today-brief', params).then(res => res);
}
// 获取今日代办
export const getTodayEvent = async (params, type = 'get') => {
  return api[type]('/gateway/v1/statistics/today-notice', params).then(res => res);
}
// 获取今日最新动态
export const getTodayNews = async (params, type = 'get') => {
  return api[type]('/gateway/v1/log/follow/new', params).then(res => res);
}
// 获取消息列表
export const getMessageList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/message', params).then(res => res);
}
// 设置消息已读
export const setMessageReaded = async (params, type = 'put') => {
  return api[type]('/gateway/v1/message/change-status?ids=' + params.ids).then(res => res);
}
// 删除消息
export const removeMessage = async (params, type = 'delete') => {
  return api[type]('/gateway/v1/message', params).then(res => res);
}
// 批量处理抢客消息
export const dealGrabBatch = async (params, type = 'put') => {
  return api[type]('/gateway/v1/message/resident-grab', params).then(res => res);
}
// 设置消息已取消
export const setMessageCancel = async (params, type = 'put') => {
  return api[type]('/gateway/v1/message/cancel', params).then(res => res);
}
// 客户顶部搜索
export const searchCustome = async (params, type = 'get') => {
  return api[type]('/gateway/v1/customer/search', params).then(res => res);
}
// 顶部搜索导出
export const searchExport = async (params, type = 'get') => {
  return api[type](`/gateway/v1/customer/search/export`, params).then(res => res);
}
// 当前客户的详细信息
export const getCurrentUserInfo = async (type = 'get') => {
  return api[type]('/gateway/v1/admin/info').then(res => res);
}
// 当前客户的联系方式
export const getCurrentUserContacts = async (type = 'get') => {
  return api[type]('/gateway/v1/admin/contacts').then(res => res);
}
/*
// 新增客户联系方式
export const addCurrentUserContacts = async (params, type = 'post') => {
  return api[type]('/gateway/v1/admin/contacts',params).then(res => res);
}
// 设置客户主联系人
export const setCurrentUserMainContacts = async (id, type = 'put') => {
  return api[type](`/gateway/v1/admin/contacts/${id}/set-main`).then(res => res);
}
// 删除经纪人联系方式
export const delCurrentUserContacts = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/admin/contacts/${id}`).then(res => res);
}
*/
export const upCurrentUserContactsAll = async (params, type = 'put') => {
  return api[type]('/gateway/v1/admin/contacts-all', params).then(res => res);
}
export const validateContactsTel = async (params, type = 'get') => {
  return api[type]('/gateway/v1/admin/contact-check',params).then(res => res);
}
// 修改自己的密码
export const setCurrentUserPwd = async (params,type = 'put') => {
  return api[type]('/gateway/v1/admin/pwd',params).then(res => res);
}
// 修改自己的资料
export const setCurrentUserMgs= async (params,type = 'put') => {
  return api[type]('/gateway/v1/admin/self',params).then(res => res);
}
// 获取整个公司的部门人员层级
export const getAllCompanyMember = async (params, type = 'get') => {
  return api[type]('/gateway/v1/dept/list-with-admin', params).then(res => res);
}
// 获取整个公司的部门人员层级(当前权限)
export const getAllCompanyMemberByAdmin = async (params, type = 'get') => {
  return api[type]('/gateway/v1/dept/list-by-permission', params).then(res => res);
}
// 校验手机号是否可用
export const checkCustomerMobile = async (params, type = 'get') => {
  return api[type]('/gateway/v1/customer/check-tel', params).then(res => res);
}
// 查找当前可合并的手机联系人
export const checkCurrentUserByMobile = async (params, type = 'get') => {
  return api[type]('/gateway/v1/customer/private-customer-name', params).then(res => res);
}
// 项目select
export const projectAutoSelect = async (params, type = 'get') => {
  return api[type]('/gateway/v1/project/search-name', params).then(res => res);
}
// 项目拓盘人列表select
export const projectDirectorAutoList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/project/search-director-name', params).then(res => res);
}
// 查看未读公告列表
export const getUnReadNoticeList = async (type = 'get') => {
  return api[type]('/gateway/v1/message/alert-index', {}, {
    headers: {
      'no-fresh-tag': true
    }
  }).then(res => res);
}
// 邀请同意拒绝
export const setInvitedOperate = async (params, type = 'post') => {
  return api[type]('/gateway/v1/admin/company-settle-action', params).then(res => res);
}
// 获取报表初始化数据
export const getReportInitial = async (type = 'get') => {
  return api[type]('/sem/v1/select-init').then(res => res);
}
// 获取投放系统配置文件
export const getPromotConfig = async (params, type = 'get') => {
  return api[type](`/sem/v1/config/sem?name=${params}`).then(res => res);
}
// 切换登录商户
export const changeLoginCompany = async (params, type = 'put') => {
  return api[type](`/gateway/v1/admin/login-company`, params).then(res => res);
}
// 免密登录
export const noSecretLogin = async (params, type = 'get') => {
  return api[type](`/gateway/v1/manage/no-secret-login`, params).then(res => res);
}
// 获取站点区域数
export const getAreaTrees = async (type = 'get') => {
  return api[type](`/gateway/v1/site-area-tree`).then(res => res);
}
// 获取离职员工列表
export const getOfflineList = async (type = 'get') => {
  return api[type](`/gateway/v1/admin/offline-admins`).then(res => res);
}
// 获取当前账户工作状态
export const getAdminWorkStatus = async (type = 'get') => {
  return api[type](`/gateway/v1/admin/work-status`).then(res => res);
}
// 设置本人休假
export const setAdminVocation = async (params, type = 'post') => {
  return api[type](`/gateway/v1/admin/vacation`, params).then(res => res);
}
// 设置经纪人休假
export const setAgentVocation = async (id, params, type = 'post') => {
  return api[type](`/gateway/v1/admin/${id}/vacation`, params).then(res => res);
}
